<template>
    <section class="fst-NotionQueryBlock">
        <div class="queryBlock">
            <div class="w-100">
                <div class="label">Запрос понятия</div>

                <el-alert
                        v-if="localNotion.querySciencePatentsDesc"
                        :closable="false"
                        class="mb-2"
                        :title="localNotion.querySciencePatentsDesc"
                        type="success"
                />

                <!-- Остался только SearchQueryEditor -->
                <SearchQueryEditor v-model="localNotion.querySciencePatents"/>
            </div>

            <div class="actionBlock">
                <el-tooltip effect="light" content="Справка по языку запросов" :open-delay="606">
                    <el-button type="text" class="help-btn" @click="handleShowHelp">
                        <i class="fa-question-circle fas"></i>
                    </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="Проверить запрос" :open-delay="606">
                    <el-button
                            type="text"
                            class="help-btn ml-0"
                            @click="handleOpenSearch(localNotion.querySciencePatents, 'Science')"
                    >
                        <i class="fa-search fas mr-1"></i>
                        <i class="fa-arrow-alt-right fas"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>

        <div class="mt-4 queryBlock">
            <div class="flex-end w-100 flex-center">
                <el-checkbox v-model="saveCopy" v-if="localNotion.id" class="mr-4">
                    Сохранить как копию
                </el-checkbox>
                <el-button
                        type="primary"
                        class="px-5"
                        @click="handleSaveNotion()"
                        :disabled="!localNotion.querySciencePatents && !localNotion.queryNewsCompanies"
                >
                    <i class="fad fa-save mr-2"></i>
                    Сохранить понятие
                </el-button>
            </div>
            <div class="actionBlock"></div>
        </div>

        <notions-editor
                v-if="showNotionEditor"
                :showNotionEditor="showNotionEditor"
                :value="notionToEdit"
                :companies="companiesList"
                @closeNotionEditor="handleCloseEditor"
        />
    </section>
</template>

<script>
    import Mixins from './mixins';
    import SearchQueryEditor from "../../libs/ace/SearchQueryEditor";
    import NotionsEditor from "./NotionsEditor";
    // PredicateEditor импорт удален

    export default {
        name: "NotionQueryBlock",
        components: { NotionsEditor, SearchQueryEditor }, // PredicateEditor удален из компонентов
        mixins: [Mixins],
        props: {
            notion: {
                type: Object,
                default: () => ({
                    id: null,
                    name: '',
                    querySciencePatents: '',
                })
            },
            companiesList: {
                type: Array,
                default: () => ([])
            },
        },
        data() {
            return {
                // Глубокая копия для избежания мутаций пропса
                localNotion: _.cloneDeep(this.notion),
                notionToEdit: {},
                showNotionEditor: false,
                saveCopy: false,
            };
        },
        watch: {
            // Синхронизация: Родитель -> Локальный
            notion: {
                handler(newVal) {
                    if (!newVal) return;

                    // Проверяем, чтобы не перерисовывать редактор (Ace) без необходимости
                    if (newVal.querySciencePatents !== this.localNotion.querySciencePatents) {
                        this.$set(this.localNotion, 'querySciencePatents', newVal.querySciencePatents);
                    }
                    if (newVal.name !== this.localNotion.name) {
                        this.localNotion.name = newVal.name;
                    }
                    if (newVal.id !== this.localNotion.id) {
                        this.localNotion.id = newVal.id;
                    }
                    if (newVal.querySciencePatentsDesc !== this.localNotion.querySciencePatentsDesc) {
                        this.$set(this.localNotion, 'querySciencePatentsDesc', newVal.querySciencePatentsDesc);
                    }
                },
                deep: true,
                immediate: true
            },

            // Синхронизация: Локальный -> Родитель
            'localNotion': {
                handler(newVal) {
                    this.$emit('input', newVal);
                },
                deep: true
            }
        },
        methods: {
            handleSaveNotion() {
                this.notionToEdit = _.merge({
                    attributeQuery: '',
                    icon: '',
                    system: false,
                    company: { id: '' }
                }, this.localNotion);

                this.notionToEdit.queryNewsCompanies = this.notionToEdit.querySciencePatents;

                this.notionToEdit.id = this.saveCopy ? null : this.notionToEdit.id;
                if (this.saveCopy) {
                    this.notionToEdit.name = this.notionToEdit.name + ' - 2';
                }

                this.showNotionEditor = true;
            },

            copyQuery(dir) {
                if (dir === 'toSciPat') {
                    this.localNotion.querySciencePatents = this.localNotion.queryNewsCompanies;
                } else {
                    this.localNotion.queryNewsCompanies = this.localNotion.querySciencePatents;
                }
            },

            handleCloseEditor() {
                this.showNotionEditor = false;
            },

            // handlePredicate удален, так как компонента PredicateEditor больше нет
        }
    };
</script>

<style lang="scss">
    .fst-NotionQueryBlock {
        .queryBlock {
            display: flex;
            align-items: center;
            gap: 15px;
            margin: 15px 0;

            .label {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .actionBlock {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                flex-direction: column;
                gap: 0;
                padding: 18px 0 0 20px;

                .help-btn {
                    font-size: 18px;
                    color: #C2D8F2;
                    &:hover{
                        color: $iq-color-primary;
                    }
                }
            }
        }

        .copy-query-block {
            margin: -25px 0 0 0;
            display: flex;
            align-items: center;
            gap: 7px;

            > * {
                text-align: center;
                justify-content: center;
            }
        }
    }

</style>